module.exports = __webpack_public_path__ + "img/logo.ae6f03fe.svg";